/**
 * Function that resolves the plugins.
 * @function resolvePlugins
 * @param {Object} props - The props of the component.
 * @param {Array} plugins - The plugins to resolve.
 * @param {Function} handleError - The error handler function.
 * @param {boolean} debug - True if debug mode is enabled, false otherwise.
 * @returns {Array} - The resolved plugins.
 * @param {Array} plugins - The plugins to resolve.
 * @param {Function} handleError - The error handler function.
 * @param {boolean} debug - True if debug mode is enabled, false otherwise.
 * @returns {Array} - The resolved plugins.
 */
const resolvePlugins = (props, plugins) =>
  plugins.reduce((accPlugins, plugin) => {
    const { definitions, ownership, id, resolver } = plugin;
    const matched = resolver(props);

    if (!matched) {
      // Significa que no matchea con la validación definida en el plugin, por ende queda descartado.
      return accPlugins;
    }

    return [...accPlugins, { definitions, ownership, isCore: false, id }];
  }, []);

export default resolvePlugins;
